export const nullElement: JSX.Element | null = null;
